import { useOutletContext } from "react-router-dom";
import CustomerProfile from "../../components/customer-profile/CustomerProfile";
import { Customer } from "../../store/services/customerService";

interface CustomerOutletContext {
  customer: Customer;
}

const CustomerProfilePage = () => {
  const { customer } = useOutletContext<CustomerOutletContext>();
  
  return <CustomerProfile customer={customer} />;
};

export default CustomerProfilePage;